<div id="loading-spinner" class="loading-screen-wrapper">
  <div class="loading-screen-icon">
    <img src="../../../../assets/img/loading.gif">
  </div>
</div>